export interface ProviderEntry {
  name: string;
  kind: 'text' | 'image';
  tier?: 'fast' | 'balanced' | 'premium';
}

/**
 * Real provider registry from ai/registry.py and ai/images/registry.py —
 * not invented. Tiers match FAST_PROVIDERS/BALANCED_PROVIDERS/
 * PREMIUM_PROVIDERS in ai/router.py exactly (OpenRouter appears in both
 * balanced and premium tiers in source, listed once here under its
 * primary/premium role since a provider's "active" status doesn't depend
 * on tier).
 */
export const textProviders: ProviderEntry[] = [
  { name: 'Groq', kind: 'text', tier: 'fast' },
  { name: 'Gemini', kind: 'text', tier: 'fast' },
  { name: 'Qwen', kind: 'text', tier: 'fast' },
  { name: 'DeepSeek', kind: 'text', tier: 'balanced' },
  { name: 'Mistral', kind: 'text', tier: 'balanced' },
  { name: 'OpenRouter', kind: 'text', tier: 'balanced' },
  { name: 'OpenAI', kind: 'text', tier: 'premium' },
  { name: 'Anthropic', kind: 'text', tier: 'premium' },
];

export const imageProviders: ProviderEntry[] = [
  { name: 'Pollinations', kind: 'image' },
  { name: 'OpenAI (gpt-image-1)', kind: 'image' },
  { name: 'Cloudflare', kind: 'image' },
  { name: 'HuggingFace', kind: 'image' },
];
